export default __webpack_public_path__ + "static/media/complianceCalendar.b66086a3.svg";